// extracted by mini-css-extract-plugin
module.exports = {"moneyFigure":"MoneyFigure_moneyFigure__j6bHe"};